// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFilterOutlinedSvg from "@fishx/icons-svg/es/asn/PFilterOutlined";
import FishxIcon from '../components/FishxIcon';

var PFilterOutlined = function PFilterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFilterOutlinedSvg
  }));
};

PFilterOutlined.displayName = 'PFilterOutlined';
export default React.forwardRef(PFilterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFilterOutlined.js
// module id = 3416
// module chunks = 0